<template>
  <top-nav :pageList="pageList"><slot></slot></top-nav>
</template>

<script>
import topNav from '@/components/topNav'
export default {
  components: {
    topNav
  },
  data() {
    return {
      pageList: []
    }
  },
  created() {
    console.log(this.$store.state.mainList)
    for (let i in this.$store.state.mainList) {
      if (this.$store.state.mainList[i].id === 50) {
        this.pageList = this.$store.state.mainList[i].children
        break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
